<template>
  <div class="domains-donut">
    <canvas ref="chartCanvas"></canvas>
  </div>
</template>

<script>
import {
  Chart,
  DoughnutController,
  ArcElement,
  Tooltip,
  Legend,
} from 'chart.js'
import { computed, nextTick, onBeforeUnmount, onMounted, ref, watch } from 'vue'

Chart.register(
    DoughnutController,
    ArcElement,
    Tooltip,
    Legend,
)

export default {
  name: 'DomainsDonutChart',

  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },

  setup(props) {
    const chartCanvas = ref(null)
    let chartInstance = null

    const toNumber = (value) => {
      const number = Number(value)

      return Number.isFinite(number) ? number : 0
    }

    const normalizedItems = computed(() => {
      return props.items.map((item) => ({
        ...item,
        value: toNumber(item.value),
        color: item.color || '#D5DBE2',
      }))
    })

    const total = computed(() => {
      return normalizedItems.value.reduce((sum, item) => {
        return sum + item.value
      }, 0)
    })

    const hasValues = computed(() => {
      return total.value > 0
    })

    const chartData = computed(() => {
      if (!hasValues.value) {
        return {
          labels: ['Нет данных'],
          values: [1],
          colors: ['#D5DBE2'],
        }
      }

      return {
        labels: normalizedItems.value.map(item => item.label),
        values: normalizedItems.value.map(item => item.value),
        colors: normalizedItems.value.map(item => item.color),
      }
    })

    const destroyChart = () => {
      if (!chartInstance) {
        return
      }

      chartInstance.destroy()
      chartInstance = null
    }

    const renderChart = async () => {
      await nextTick()

      if (!chartCanvas.value) {
        return
      }

      destroyChart()

      chartInstance = new Chart(chartCanvas.value, {
        type: 'doughnut',
        data: {
          labels: chartData.value.labels,
          datasets: [
            {
              data: chartData.value.values,
              backgroundColor: chartData.value.colors,
              borderWidth: 0,
              hoverOffset: hasValues.value ? 2 : 0,
              spacing: 0,
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          cutout: '64%',
          animation: false,
          plugins: {
            legend: {
              display: false,
            },
            tooltip: {
              enabled: hasValues.value,
              displayColors: true,
              callbacks: {
                label: (context) => {
                  return `${context.label}: ${context.parsed} чел.`
                },
              },
            },
            datalabels: {
              display: false,
            },
          },
        },
      })
    }

    onMounted(() => {
      renderChart()
    })

    onBeforeUnmount(() => {
      destroyChart()
    })

    watch(
        chartData,
        () => {
          renderChart()
        },
        {
          deep: true,
        }
    )

    return {
      chartCanvas,
    }
  },
}
</script>

<style scoped lang="scss">
.domains-donut {
  width: 104px;
  height: 104px;
  flex: 0 0 104px;
}
</style>